export default "__VITE_ASSET__Cb7ANbx9__"